import type { FaireProductEntity } from "../../entity_types/product";

export const p_ddn94ddrje: FaireProductEntity = {
  token: "p_ddn94ddrje",
  type: "product",
  name: "Freak Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/278bf5aa5befaa5071996d01fd4a73cc7d93fa6e5bf14b55c2cf6fda82e6c7f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0dd4b1fdcb51b6d2ec5961113e25bbc55078d02049385555b76e312500b955da.jpeg",
    "https://cdn.faire.com/fastly/881c92f52e6c6f6fe7a0c34dbe54fbfeff8fd23088d0d3805282df0fd4366124.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/78f4136eb50c943e02e56586f5ed4dcc65414cbcab89485c72402554931e2451.jpeg",
    "https://cdn.faire.com/fastly/af5d5f692dfa7034a92d47584627687c8346781e9b914892e4a538bcd7f5aa11.jpeg",
    "https://cdn.faire.com/fastly/2bb6e5c66b3f3f8b381ef9ae0102fcd5fb55f4661118f3e2c088bc3c09dfeac0.jpeg",
    "https://cdn.faire.com/fastly/86f8da18d17dae2c34b61658e58d19177fde3e0f9a01580681109da90a9e2fee.jpeg",
    "https://cdn.faire.com/fastly/ea91b4f181c69098bed9b55370dba64ab8725ffa1ec146510c03627b1d5fdeb0.jpeg",
    "https://cdn.faire.com/fastly/ccfbd1d21721a67dd0c2eb7a43aba2b87006c7d285c341dd55a8be9d25571529.jpeg"
  ],
  priceDollars: 6.75,
  description: "Sometimes all it takes is a single word to let the world know what's up. These socks are for all the FREAKS out there. For when your freak flag is too cumbersome, opt for freak socks. 😝\n\nBold, expressive socks made for gym-goers, style risk-takers, or anyone ready to show their freaky side. A fun gift or standout accessory for shops that celebrate individuality and loud style.\n\nKey features of our Freak gym socks:\n\n• Unisex sizing\n• One size fits most \n• Comfy cushion foot\n• No toe seam\n• Made with high quality cotton in the USA\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:13.652Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
